import React, { Component } from 'react';

import EndpointDialog from './SearchServicesEndpointDialog'
import SecondaryAppDialog from './SearchServicesSecondaryAppDialog'
import SearchServices from './SearchServicesTableComponent'
import SearchServicesDialog from './SearchServicesTableDialog'
import SearchServicesServerDialog from './SearchServicesServerDialog'
import { actions } from './SearchServicesTableReducer'
import { connect } from 'react-redux'
import { reduxForm, reset } from 'redux-form'

class Wrapper extends Component {
    componentDidMount() {   
        this.props.fetch();
    }
    render() {
        return (
            <React.Fragment>
                <SearchServices {...this.props} />                
                <SearchServicesConnectDialog {...this.props} />
                <EndpointConnectDialog {...this.props} />
                <ServerConnectDialog {...this.props} />
                <SecondaryAppConnectDialog {...this.props} />
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const result = state.waas.searchServices.fetcher.items;

    return {
        fetcher: state.waas.searchServices.fetcher,
        items: result.results || [],
        count: result.count || 0,
        servicesLocations: state.waas.searchServices.searchServices.servicesLocations,
        domains: state.waas.searchServices.searchServices.domains,
        sendingRequest: state.waas.searchServices.searchServices.isRequestingExtendTrial,
        requestStatus: state.waas.searchServices.searchServices.extendTrialResult || {},
        removeRestrictionsResult: state.waas.searchServices.searchServices.removeRestrictionsResult || {}
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        fetch: (params) => {              
            dispatch(actions.trigger(params))
        },
        onSearch: (searchPhrase) => {
            dispatch(actions.search(searchPhrase))
        },
        toggleOptionsDialog: (account_id) => {
            dispatch(actions.toggleOptionsDialog(account_id))
        },
        toggleEndpointDialog: (service_id) => {
            dispatch(actions.toggleEndpointDialog(service_id))
        },
        toggleSecondaryAppDialog: (service_id) => {
            dispatch(actions.toggleSecondaryAppDialog(service_id))
        },
        toggleServiceLocations: (service_id) => {
            dispatch(actions.toggleServiceLocations(service_id))
        },
        fetchRlc: (service_id, rlc_name) => {
            dispatch(actions.fetchRlc(service_id, rlc_name))
        },
        toggleServerHealthDialog: (server_id) => {
            dispatch(actions.toggleServerHealthDialog(server_id))
        },
        fetchContainerInfo: (service_id, container_index) => {
            dispatch(actions.fetchContainerInfo(service_id, container_index))
        },
    }
}

// URL DIALOG

const mapDialogUrlStateToProps = (state, ownProps) => {
    return {
        isOpen: state.waas.searchServices.searchServices.isOpen,
        account: state.waas.searchServices.searchServices.account,
        licenses: state.waas.searchServices.searchServices.licenses,       
        licensesData: state.waas.searchServices.searchServices.licenses_data,
    }
}

const mapDialogUrlDispatchToProps = (dispatch, ownProps) => {
    return {
        close: () => {
            dispatch(actions.toggleOptionsDialog())
        },
        extendTrial: (account_id, serial, days) => {
            dispatch(actions.extendTrial(account_id, serial, days))
        },
        generateToken: (account_id) => {
            dispatch(actions.generateToken(account_id))
        },
        removeRestrictions: (account_id) => {
            dispatch(actions.removeRestrictions(account_id))
        }
    }
}

const onSubmitUrlDialog = (values, dispatch, props) => {   // reduxForm onChange

    const newValues = {
        id: values.id,
        name: values.name,
        enabled: values.enabled,
        action: values.action,
        url_match: values.url_match,
    }

    if(values.action === 'Redirect'){
        newValues.action = (values.redirectType === 'Temporary') ? 'Temporary Redirect' : 'Permanent Redirect';
        newValues.redirect_url = values.redirect_url;
    }else if(values.action === 'Allow'){
        newValues.action = values.logRequestInFirewallLogs ? 'Allow and Log' : 'Allow';
    }else if(values.action === 'Deny'){
        newValues.action = values.logRequestInFirewallLogs ? 'Deny and Log' : 'Deny with no Log';
        newValues.follow_up_action = values.follow_up_action;
        if(values.follow_up_action === 'Block Client-IP')
        newValues.follow_up_action_time = values.follow_up_action_time;    
    }

    return new Promise((resolve, reject) => {
        dispatch(actions.saveUrl(props.waasId, newValues, reject, resolve))
    })
}

export const SearchServicesDialogFormed = reduxForm({
    form: 'searchServicesDialog',
    enableReinitialize: true,
    onSubmit: onSubmitUrlDialog,
})(SearchServicesDialog);

export const SearchServicesConnectDialog = connect(mapDialogUrlStateToProps, mapDialogUrlDispatchToProps)(SearchServicesDialogFormed);

// ENDPOINT DIALOG

const mapDialogEndpointStateToProps = (state, ownProps) => {
    return {
        initialValues: state.waas.searchServices.searchServices.initialValues,
        isOpen: state.waas.searchServices.searchServices.isEndpointDialogOpen,       
    }
}

const mapDialogEndpointDispatchToProps = (dispatch, ownProps) => {
    return {
        close: () => dispatch(actions.toggleEndpointDialog()),
    }
}

const onSubmitEndpointDialog = (values, dispatch, props) => {   // reduxForm onChange
    return new Promise((resolve, reject) => {
        dispatch(actions.saveEndpointDialog(values, reject, resolve))
    })
}

export const EndpointDialogFormed = reduxForm({
    form: 'EndpointDialog',
    enableReinitialize: true,
    onSubmit: onSubmitEndpointDialog,
})(EndpointDialog);

export const EndpointConnectDialog = connect(mapDialogEndpointStateToProps, mapDialogEndpointDispatchToProps)(EndpointDialogFormed);

// Server health dialog

const mapServerDialogDispatchToProps = (dispatch, ownProps) => {
    return {
        close: () => dispatch(actions.toggleServerHealthDialog()),
    }
};

const mapServerDialogStateToProps = (state, ownProps) => {
    return {
        isOpen: state.waas.searchServices.searchServices.isServerDialogOpen,
        containers: state.waas.searchServices.searchServices.server_health,  
        loading: state.waas.searchServices.searchServices.isServerDialogLoading,  
    }
};

export const ServerConnectDialog = connect(mapServerDialogStateToProps, mapServerDialogDispatchToProps)(SearchServicesServerDialog);

export default connect(mapStateToProps, mapDispatchToProps)(Wrapper)

// Secondary App Dialog

const mapDialogSecondaryAppStateToProps = (state, ownProps) => {
    return {
        isOpen: state.waas.searchServices.searchServices.isSecondaryAppDialogOpen,      
    }
}

const mapDialogSecondaryAppDispatchToProps = (dispatch, ownProps) => {
    return {
        close: () => { 
            dispatch(actions.toggleSecondaryAppDialog()) 
            dispatch(reset('SecondaryAppDialog'))
        },
    }
}

const onSubmitSecondaryAppDialog = (values, dispatch, props) => {
    return new Promise((resolve, reject) => {
        dispatch(actions.saveSecondaryAppDialog(values, reject, resolve))
    })
}

export const SecondaryAppDialogFormed = reduxForm({
    form: 'SecondaryAppDialog',
    enableReinitialize: true,
    onSubmit: onSubmitSecondaryAppDialog,
})(SecondaryAppDialog);

export const SecondaryAppConnectDialog = connect(mapDialogSecondaryAppStateToProps, mapDialogSecondaryAppDispatchToProps)(SecondaryAppDialogFormed);
